'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LackOfTErrorMessage = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _contextTypes = require('./contextTypes');

var _contextTypes2 = _interopRequireDefault(_contextTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LackOfTErrorMessage = exports.LackOfTErrorMessage = 'Unable to access t function. Ensure that <TranslatorProvider> is in place' + ' provided with translations object.';

var validateAndProvideT = function validateAndProvideT(WrappedComponent) {
    var TProvider = function TProvider(props, _ref) {
        var t = _ref.t;

        if (!t) {
            throw new Error(LackOfTErrorMessage);
        }

        return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, props, {
            t: t
        }));
    };
    TProvider.contextTypes = _contextTypes2.default;

    return TProvider;
};

/**
 * Higher order component, that wraps other components to provide t function to their props
 * @param {React.Element<*>} wrappedComponent Component that need to use translator
 * @returns {React.Element<*>} A react element
 */
var withTranslator = function withTranslator(wrappedComponent) {
    return (0, _recompose.compose)((0, _recompose.setDisplayName)((0, _recompose.wrapDisplayName)(wrappedComponent, 'withTranslator')), validateAndProvideT)(wrappedComponent);
};

exports.default = withTranslator;
//# sourceMappingURL=withTranslator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-translations/dist/main/withTranslator.js
// module id = 626
// module chunks = 0